import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Menu } from 'lucide-react';
import { categories, Tool } from '../data/tools';
import { ToolDisplay } from '../components/ToolDisplay';
import { HomeContent } from '../components/HomeContent';
import { MobileSidebar } from '../components/MobileSidebar';
import { Button } from '../components/ui/Button';
import { useSearch } from '../contexts/SearchContext';

interface HomePageProps {
  searchQuery?: string;
  debugSearchQuery?: string;
  debugTimestamp?: number;
}

export const HomePage: React.FC<HomePageProps> = () => {
  const { t } = useTranslation();
  const { category: categoryId, toolId } = useParams<{ category?: string; toolId?: string }>();
  const { searchQuery } = useSearch();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);



  // 从URL获取当前工具
  const getCurrentTool = (): Tool | null => {
    if (categoryId && toolId) {
      const category = categories.find(cat => cat.id === categoryId);
      return category?.tools.find(tool => tool.id === toolId) || null;
    }
    return null;
  };

  const currentTool = getCurrentTool();
  const isHomePage = !categoryId && !toolId;

  // Scroll to top when tool changes
  useEffect(() => {
    if (currentTool) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [currentTool]);

  return (
    <div className="h-full">
      {/* Mobile Tool Selector - only show when not on home page */}
      {!isHomePage && (
        <div className="lg:hidden mb-4 p-4 border-b border-gray-200 dark:border-gray-700">
          <Button
            variant="outline"
            onClick={() => setIsSidebarOpen(true)}
            className="w-full justify-start"
          >
            <Menu className="w-4 h-4 mr-2" />
            {currentTool ? t(currentTool.name) : t('home.selectTool')}
          </Button>
        </div>
      )}

      {/* Mobile Sidebar */}
      <MobileSidebar isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />

      {/* Main Content */}
      <div className="h-full">
        {isHomePage ? (
          <HomeContent searchQuery={searchQuery} />
        ) : (
          <ToolDisplay tool={currentTool} className="h-full" />
        )}
      </div>
    </div>
  );
};